
    <input dw-input placeholder="" [(ngModel)]="filterText" (ngModelChange)="filterChanged()" #filterInput>
  